import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { ActionButtonComponent } from './action-button/action-button.component';
import { ModalsComponent } from './modals.component';
import { ModalsService } from './modals.service';

@NgModule({
  declarations: [ModalsComponent, ActionButtonComponent],
  exports: [ModalsComponent, ActionButtonComponent],
  imports: [CommonModule, NgbDatepickerModule, NgbTimepickerModule, FormsModule, TranslateModule],
  providers: [],
})
export class ModalsModule {
  static forRoot(): ModuleWithProviders<ModalsModule> {
    return {
      ngModule: ModalsModule,
      providers: [ModalsService],
    };
  }
}
